import moment from "moment";
import {
  api_request, answer_request
} from '@/utils/api';
import {
  isDEV, LocationOrigin, dict2params
} from "@/utils/request";
// let isDEV = false;
//新建对话
export const post_biogpt_chat = (rq, func)=>{
  // if(isDEV){
  //   func({
  //     "data": {
  //       "account": "hpp_test",
  //       "chat_name": "test",
  //       "chat_no": 1
  //     },
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  api_request({
    type: 'post',
    url: '/api/v2/biogpt/chat/',
    data: rq,
    crud_name: '新建对话',
    success: func
  });
};
let short_answer_url = LocationOrigin + '/lins/short/answer/';
//lins问答
export const get_short_answer_stream = async (data, func)=>{
  // console.log(rq);
  // data.az = localStorage.getItem('access-token');
  let url = short_answer_url + '?' + dict2params(data);
  var source = new EventSource(url);
  // let references = [];
  // let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    console.log('eventData', typeof eventData);
    try {
      const parseData = JSON.parse(eventData);
      // const {content, tag} = parseData;
      // console.log('content', content);
      func( parseData);
    }
    catch (e) {
      func({content: eventData});
      console.log('JSON.parse(eventData) error===', e);
    }
    // if (parsedData.url) {
    //     references = [...references, parsedData];
    //     console.log('References:', references);
    // }
    //
    // if (parsedData.answer) {
    //     const answer = parsedData.answer;
    //     // 答案输出是流式的，有多次返回
    //     // 遇到终止符时关闭sse连接
    //     if (answer.includes(endSign)){
    //         source.close();
    //     }
    //     if(func) func(answer, references, n);
    //     n ++;
    // }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    // func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};
//lins问答
export const get_answer_stream = async (api_url, data, func)=>{
  // console.log(rq);
  data.az = localStorage.getItem('access-token');
  let url = LocationOrigin + api_url + '?' + dict2params(data);
  var source = new EventSource(url);
  // let references = [];
  // let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    console.log('eventData', typeof eventData);
    try {
      const parseData = JSON.parse(eventData);
      // const {content, tag} = parseData;
      // console.log('content', content);
      func( parseData);
    }
    catch (e) {
      func({content: eventData});
      console.log('JSON.parse(eventData) error===', e);
    }
    // if (parsedData.url) {
    //     references = [...references, parsedData];
    //     console.log('References:', references);
    // }
    //
    // if (parsedData.answer) {
    //     const answer = parsedData.answer;
    //     // 答案输出是流式的，有多次返回
    //     // 遇到终止符时关闭sse连接
    //     if (answer.includes(endSign)){
    //         source.close();
    //     }
    //     if(func) func(answer, references, n);
    //     n ++;
    // }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    // func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};
//paper问答
export const post_aftergo_chat_message = async (data, func)=>{
  // console.log(rq);
  // data.az = localStorage.getItem('access-token');
  let url = short_answer_url + '?' + dict2params(data);
  var source = new EventSource(url);
  // let references = [];
  // let n  = 0;
  source.onmessage = function(event) {
    const eventData = event.data;
    console.log('eventData', typeof eventData);
    try {
      const parseData = JSON.parse(eventData);
      // const {content, tag} = parseData;
      // console.log('content', content);
      func( parseData);
    }
    catch (e) {
      func({content: eventData});
      console.log('JSON.parse(eventData) error===', e);
    }
    // if (parsedData.url) {
    //     references = [...references, parsedData];
    //     console.log('References:', references);
    // }
    //
    // if (parsedData.answer) {
    //     const answer = parsedData.answer;
    //     // 答案输出是流式的，有多次返回
    //     // 遇到终止符时关闭sse连接
    //     if (answer.includes(endSign)){
    //         source.close();
    //     }
    //     if(func) func(answer, references, n);
    //     n ++;
    // }
  };
  source.onerror = function(error) {
    // Handle error
    console.log(error);
    // func('INTERNAL SERVER ERROR' + endSign);
    source.close();
  };
};

export const post_short_answer = (rq, func)=>{
  // if(isDEV){
  //   func({
  //     "data": {
  //       "account": "hpp_test",
  //       "chat_name": "test",
  //       "chat_no": 1
  //     },
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  answer_request({
    type: 'post',
    url: '/lins/short/answer/',
    data: rq,
    crud_name: 'lins问答',
    success: func
  });
};
export const get_biogpt_chat = (func)=>{

  api_request({
    type: 'get',
    url: '/api/v2/biogpt/chat/',
    crud_name: '查看对话列表',
    success: func
  });
};
function getItem(
  label,
  key,
  icon,
  children,
  type,
) {
  return {
    key,
    icon,
    children,
    label,
    type,
    menu: label,
  };
}
export const formatChats = (res)=>{
  let {data} = res;
  let items1 = [];
  let items7 = [];
  let items30 = [];
  let more = [];
  let now = new Date();
  data = data || [];
  data.reverse();
  data.map(item=>{
    let {chat_name, create_time, chat_no} = item;
    create_time *= 1000;
    let diff = now - create_time;
    let ms = 24 * 60 * 60 * 1000;
    if(!chat_name) chat_name = moment(create_time).format('YYYY-MM-DD HH:mm:ss');
    let menuItem = {label: chat_name, key: chat_no, chat_no};
    if(diff <= ms) items1 = [...items1, menuItem];
    else if(diff <= 7 * ms) items7 = [...items7, menuItem];
    else if(diff <= 30 * ms) items30 = [...items30, menuItem];
    else more = [...more, menuItem];
  });
  let menuItems = [];
  if(items1.length > 0) menuItems = [...menuItems, getItem('Today', '1d', null, items1, 'group')];
  if(items7.length > 0) menuItems = [...menuItems, getItem('Previous 7 Days', '7d', null, items7, 'group'),];
  if(items30.length > 0) menuItems = [...menuItems, getItem('Previous 30 Days', '30d', null, items30, 'group'),];
  if(more.length > 0) menuItems = [...menuItems, getItem('More', 'more', null, more, 'group')];
  return menuItems;
};
export const delete_biogpt_chat = (rq, func)=>{
  if(isDEV){
    func({
      "data": {
        "chat_no": 1
      },
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'delete',
    url: '/api/v2/biogpt/chat/',
    data: rq,
    crud_name: '删除对话',
    success: func
  });
};

export const post_biogpt_chat_query = (rq, func)=>{
  // if(isDEV){
  //   // 普通对话请求示例
  //   rq = {
  //     "chat_no": 1,
  //     "message_type": 1,
  //     "msg": "你好",
  //     "model": "GPT-3.5"
  //   };
  //   // 发起分析任务示例
  //   // rq = {
  //   //     "chat_no": 1,
  //   //     "message_type": 2,
  //   //     "msg": "我有一个二分类数据集：{origin.csv}，包含了一些数据和对应的标签，需要先划分数据集，并选择五个合适的分类器做预测，进行acc的计算，最后选择最优的分类器进行预测。",
  //   //     "model": "GPT-3.5",
  //   //     "task_files": [
  //   //         "/mnt/data/biogpt/example/origin.csv"
  //   //     ]
  //   // }
  //   func({
  //     "data": {task_id: 'demo', payload: {message: 'started', stage: 'start'}},
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  api_request({
    type: 'post',
    url: '/api/v2/biogpt/chat/query/',
    data: rq,
    crud_name: '普通对话、发起分析',
    success: func
  });
};
export const get_biogpt_chat_messages = (rq, func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/chat/messages/',
    data: rq,
    crud_name: '查看聊天记录',
    success: func
  });
};
export const get_biogpt_task = (rq, func)=>{
  // if(isDEV){
  //   // rq = {
  //   //     "chat_no": 1
  //   // }
  //   // 0failed 1start 2improve_prompt 3tool_score 4workflow 5code 6summary 7completed
  //   // let stage = 'failed', task_stage = 0;
  //   let stage = 'completedNew', task_stage = 7;
  //   // let stage = 'start', task_stage = 1;
  //   // let stage = 'improve_prompt', task_stage = 2;
  //   // let stage = 'tool_score', task_stage = 3;
  //   func({
  //     "data": {
  //       "add_time": 1714092872,
  //       "chat_no": 1,
  //       "is_self": 1,
  //       "message_no": 18,
  //       "message_type": 2,
  //       "model": "GPT-3.5",
  //       "payload": require('@/json/api-format/'+stage+''),
  //       "task_files": [
  //         "/mnt/data/biogpt/example/origin.csv"
  //       ],
  //       "task_id": "8573b275-21b2-40d2-b06a-a1263d07eadc",
  //       "task_stage": task_stage,
  //       "update_time": 1714092872
  //     },
  //     "message": "success",
  //     "status": 1000001
  //   });
  //   return;
  // }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/task/',
    data: rq,
    crud_name: '查看聊天记录',
    success: func
  });
};
export const get_biogpt_task_list = (func)=>{
  if(isDEV){
    func({
      "status": 1000001,
      "message": "success",
      "data": [
        {
          "task_stage": 0,
          "task_id": "a2c28592-ab0d-4406-a411-aba9467ab8f0",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714014975,
          "stars": 3,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714014975
        },
        {
          "task_stage": 2,
          "task_id": "6a74f22f-5b51-4199-88e2-0bcf2d372bc6",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714015422,
          "stars": 0,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714015043
        },
        {
          "task_stage": 6,
          "task_id": "2fa36850-7e80-4e98-8902-b00cd01e9d0e",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714016373,
          "stars": 0,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714016373
        },
        {
          "task_stage": 7,
          "task_id": "2fa36850-7e80-4e98-8902-b00cd01e9d0e",
          "cite_task_id": null,
          "task_query": null,
          "update_time": 1714016373,
          "stars": 0,
          "model": "GPT-3.5",
          "public": 0,
          "cite_no": 0,
          "add_time": 1714016373
        }
      ]
    });
    return;
  }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/task/list/',
    crud_name: '查看任务列表',
    success: func
  });
};
export const put_biogpt_task = (rq, func)=>{
  if(isDEV){
    func({
      "status": 2000001,
      "message": "success",
      "data": {
        "task_id": "8573b275-21b2-40d2-b06a-a1263d07eadc",
        "public": 1
      }
    });
    return;
  }
  api_request({
    type: 'put',
    data: rq,
    url: '/api/v2/biogpt/task/',
    crud_name: '查看任务列表',
    success: func
  });
};
export const get_biogpt_tools = (rq, func)=>{
  if(isDEV){
    func({
      "data": [
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1721095164,
          "cite_count": 0,
          "description": "This is a regression tool. Enter two csv files, the training set and the test set. Also enter the column name for the label column. Use the tool to train on the training set and then on the test set Predict and output the prediction result file on the test set. The output result file has the predicted value column \"Predicted\" added compared to the input test set. The algorithm used is SVM Regressor",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": "adcced84-d5b7-40cd-bb50-69fb24c4dc29",
          "task_query": "我有一个突变的vcf文件{GJX-lung.pass.vcf}，利用vcf2maf5进行变异注释生成maf文件",
          "tool_id": "5ee968a890b243fea69312b0eaddd2bd",
          "tool_name": "vcf2maf5",
          "tool_release": 0,
          "update_time": 1721095164,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720172180,
          "cite_count": 0,
          "description": "Variant Call Format files\n",
          "failed_message": null,
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201721054306104\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "a7d8ae834c1945bf849e78ff210db831",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720172180,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720171509,
          "cite_count": 0,
          "description": "A tool used to convert a VCF file into a MAF file\n",
          "failed_message": "",
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201714964205961\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "8301c754110a44c0a9d3bdbe65ef8c55",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720171509,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720149657,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "6bafd9f5f76e4e02b5118f3a6c55632f",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720149657,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148936,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "ad5e7f6f805b49dfbf9765a2cb0d859c",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720148936,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148430,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "39831f320e8845548f384c0a918f2ddb",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720148430,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          command: "perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/GJX-lung.pass.vcf --output-maf /io_data/GJX-lung.pass.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97",
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074781,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 422",
          "mount_point": null,
          "param_input": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": -1,
          "task_id": null,
          "task_query": null,
          "tool_id": "d67f681efa5448319275f57ba9ef9aec",
          "tool_name": "vcf2maf6",
          "fun_name": "vcf2maf6",
          "tool_release": 0,
          "update_time": 1720769072,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074407,
          "cite_count": 0,
          "description": "描述",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "72c8ca3abb4d4cf98d49d76841cb8739",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720074407,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1719991541,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 500",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "d98102051cf741b2881a450e3faf0675",
          "tool_name": "vcf2maf2",
          "tool_release": 0,
          "update_time": 1720509885,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        }
      ],
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/tools/mine/',
    data: rq,
    crud_name: '查看我的工具',
    success: func
  });
};
export const get_biogpt_tools_admin = (rq, func)=>{
  if(isDEV){
    func({
      "data": [
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1721095164,
          "cite_count": 0,
          "description": "描述",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/5ee968a890b243fea69312b0eaddd2bd/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": "adcced84-d5b7-40cd-bb50-69fb24c4dc29",
          "task_query": "我有一个突变的vcf文件{GJX-lung.pass.vcf}，利用vcf2maf5进行变异注释生成maf文件",
          "tool_id": "5ee968a890b243fea69312b0eaddd2bd",
          "tool_name": "vcf2maf5",
          "tool_release": 0,
          "update_time": 1721095164,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720172180,
          "cite_count": 0,
          "description": "Variant Call Format files\n",
          "failed_message": null,
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/a7d8ae834c1945bf849e78ff210db831/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201721054306104\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "a7d8ae834c1945bf849e78ff210db831",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720172180,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720171509,
          "cite_count": 0,
          "description": "A tool used to convert a VCF file into a MAF file\n",
          "failed_message": "",
          "mount_point": "/opt",
          "param_input": [
            {
              "description": "Variant Call Format files\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Mutation annotation information (MAF) format file\n",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/8301c754110a44c0a9d3bdbe65ef8c55/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "def vcf_to_maf(input_vcf):\n    \n    if not input_vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(input_vcf.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201714964205961\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input_vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_maf = output_header0+\".maf\"\n    for f in [output_maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_maf",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "8301c754110a44c0a9d3bdbe65ef8c55",
          "tool_name": "vcf_to_maf",
          "tool_release": 0,
          "update_time": 1720171509,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720149657,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/6bafd9f5f76e4e02b5118f3a6c55632f/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "6bafd9f5f76e4e02b5118f3a6c55632f",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720149657,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148936,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/ad5e7f6f805b49dfbf9765a2cb0d859c/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 3,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 4,
          "task_id": null,
          "task_query": null,
          "tool_id": "ad5e7f6f805b49dfbf9765a2cb0d859c",
          "tool_name": "vcf2maf",
          "tool_release": 1,
          "update_time": 1720148936,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720148430,
          "cite_count": 0,
          "description": "描述",
          "failed_message": null,
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/39831f320e8845548f384c0a918f2ddb/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 1,
          "task_id": null,
          "task_query": null,
          "tool_id": "39831f320e8845548f384c0a918f2ddb",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720148430,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          command: "perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/GJX-lung.pass.vcf --output-maf /io_data/GJX-lung.pass.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97",
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074781,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 422",
          "mount_point": null,
          "param_input": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "input_vcf",
              "param_name": "/io_data/GJX-lung.pass.vcf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "test",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "get_from_input": true,
              "get_from_output": true,
              "input_param": "input_vcf",
              "name": "output_maf",
              "param_name": "/io_data/GJX-lung.pass.maf",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/042717e6755b4c3cb81e5ac2447b6bb8/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": -1,
          "task_id": null,
          "task_query": null,
          "tool_id": "d67f681efa5448319275f57ba9ef9aec",
          "tool_name": "vcf2maf6",
          "fun_name": "vcf2maf6",
          "tool_release": 0,
          "update_time": 1720769072,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1720074407,
          "cite_count": 0,
          "description": "描述",
          "failed_message": "",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/72c8ca3abb4d4cf98d49d76841cb8739/test.maf",
              "type": "file"
            }
          ],
          "review_message": "",
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n    \n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n    \n    \n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "72c8ca3abb4d4cf98d49d76841cb8739",
          "tool_name": "vcf2maf",
          "tool_release": 0,
          "update_time": 1720074407,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        },
        {
          "abandon": 0,
          "account": "hpp_test",
          "add_time": 1719991541,
          "cite_count": 0,
          "description": "test2",
          "failed_message": "Use run tool get Failed: 500",
          "mount_point": null,
          "param_input": [
            {
              "description": "Variant Call Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/GJX-lung.pass.vcf",
              "name": "vcf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/GJX-lung.pass.vcf",
              "type": "file"
            }
          ],
          "param_output": [
            {
              "description": "Maf Format files",
              "example": "/mnt/data/bioinfogpt/users/hpp_test/test.maf",
              "name": "maf_file",
              "system_example": "/mnt/data/bioinfogpt/tools/examples/d98102051cf741b2881a450e3faf0675/test.maf",
              "type": "file"
            }
          ],
          "review_message": null,
          "review_status": 1,
          "script": "\nimport os\nimport docker\n\ndef vcf_to_maf(vcf_file):                       # 工具名， 参数列表\n    if not vcf_file.endswith(\".vcf\"):           # 输入文件检查\n        raise ValueError(\"Invalid file name\")\n\n    current_path = os.getcwd()\n    output_header = vcf_file.split(\".\")[0]       # 输出文件前缀（可选）\n    client = docker.from_env()\n\n    container_config = {                    \n    'image': 'bc_vcf2maf',                  # 使用的镜像\n    'command': '/bin/bash',                 \n    'tty': True,                            \n    'stdin_open': True,                     \n    'volumes': {                            # 挂载主机目录到容器中\n        current_path: {                     # 输入输出文件所在目录（一般不需要修改）\n            'bind': '/io_data',             # 映射到docker中的目录\n            'mode': 'rw'\n        },\n        '/mnt/data/fastq2vcf': {            # docker中要运行的脚本所在目录\n            'bind': '/data',                # 映射到docker中的目录\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n\n    # docker中的运行脚本的命令，指定输入文件与输出文件等\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{vcf_file} --output-maf /io_data/{output_header}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n\n    output = container.exec_run(command)     \n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output_file = output_header + \".maf\"                     # 后处理：文件存在检查\n    # output_file1, output_file2 = \"xxx.maf\", \"xxxx.maf\"    \n    for f in [output_file]:                                 # 后处理：文件存在检查\n    # for f in [output_file1, output_file2]\n        if not os.path.exists(f):                           \n            raise FileNotFoundError(f\"{f} is not found\")\n    return output_file                                      # 函数的返回值（输出文件的文件名）\n\nif __name__ == \"__main__\":\n    res = vcf_to_maf(\"GJX-lung.pass.vcf\")\n    print(res)\n",
          "stage": 2,
          "task_id": null,
          "task_query": null,
          "tool_id": "d98102051cf741b2881a450e3faf0675",
          "tool_name": "vcf2maf2",
          "tool_release": 0,
          "update_time": 1720509885,
          "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar",
          "user_tar_path": null
        }
      ],
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/tools/admin/',
    data: rq,
    crud_name: '管理员查看工具列表',
    success: func
  });
};
export const post_biogpt_tools_admin_review = (rq, func)=>{
  if(isDEV){
    func({
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: 'post',
    url: '/api/v2/biogpt/tools/admin/review/',
    data: rq,
    crud_name: '管理员审核工具, 用户具有C及以上权限, 只能审核质检完成且待审核的工具',
    success: func
  });
};
export const crud_biogpt_tools = (method, rq, func)=>{
  if(isDEV){
    func({
      "data": {
        "account": "hpp_test",
        "description": "描述",
        "param_input": [
          {
            "description": "xxx",
            "example": "1123",
            "name": "input1",
            "system_example": "1123",
            "type": "string"
          }
        ],
        "param_output": [
          {
            "description": "xxx",
            "example": "1123",
            "name": "output1",
            "system_example": "1123",
            "type": "string"
          }
        ],
        "script": "import os",
        "tool_id": "d98102051cf741b2881a450e3faf0675",
        "tool_name": "vcf2maf",
        "user_image_path": "/mnt/data/bioinfogpt/tools/images/bioinfogpt/bc_vcf2maf.tar"
      },
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    type: method,
    url: '/api/v2/biogpt/tools/',
    data: rq,
    crud_name: '新建/更新工具',
    success: func
  });
};


export const post_biogpt_tools_release = (data, func)=>{
  if(isDEV){
    func({
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/tools/release/',
    // data: rq,
    crud_name: '上线工具',
    success: func
  });
};

export const post_biogpt_tools_verify = (data, func)=>{
  if(isDEV){
    func({
      "message": "success",
      "status": 1000001
    });
    return;
  }
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/tools/verify/',
    // data: rq,
    crud_name: '验证工具命名',
    success: func
  });
};
//aftergo创建分享码
export const post_biogpt_subscribe_share = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/subscribe/share/',
    data: rq,
    crud_name: 'aftergo创建分享码',
    success: func
  });
};
//aftergo文献上传创建分享码
export const post_biogpt_upload_share = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/aftergo/paper/share/',
    data: rq,
    crud_name: 'aftergo文献上传创建分享码',
    success: func
  });
};
//aftergo查看文献状态
export const get_biogpt_upload_status = (rq, func)=>{
  api_request({
    type: 'GET',
    url: '/api/v2/biogpt/aftergo/paper/upload/',
    data: rq,
    crud_name: 'aftergo查看文献状态',
    success: func
  });
};
//aftergo分享码获取订阅详情
export const post_biogpt_skip_subscribe_info = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/skip/aftergo/share/subscribe/info/',
    data: rq,
    crud_name: 'aftergo分享码获取订阅详情',
    success: func
  });
};
//aftergo分享码获取一次推送内容
export const post_biogpt_skip_subscribe_share_push_info = (rq, func)=>{
  api_request({
    type: 'POST',
    url: '/api/v2/biogpt/skip/aftergo/share/push/info/',
    data: rq,
    crud_name: 'aftergo分享码获取一次推送内容',
    success: func
  });
};
//aftergo获取上传的文章解读（用户）
export const post_biogpt_paper_upload_info = (rq, func)=>{
  api_request({
    type: 'POST',
    base_url: LocationOrigin + '/api/v2/biogpt/aftergo/paper/upload/info/',
    url: '',
    data: rq,
    crud_name: 'aftergo分享码获取文章详情',
    success: func
  });
};
//aftergo分享码获取文章详情
export const post_biogpt_subscribe_share_paper = (rq, func)=>{
  if(isDEV){
    let res = require('@/json/share');
    func(res);
    return;
  }
  api_request({
    type: 'POST',
    base_url: LocationOrigin + '/api/v2/biogpt/skip/aftergo/share/paper/',
    url: '',
    data: rq,
    crud_name: 'aftergo分享码获取文章详情',
    success: func
  });
};
//aftergo获取文章详情
export const get_biogpt_aftergo_paper = (rq, func)=>{
  api_request({
    type: 'GET',
    url: ' /api/v2/biogpt/aftergo/paper/',
    data: rq,
    crud_name: 'aftergo获取文章详情',
    success: func
  });
};
//新建订阅 更新订阅
export const p_biogpt_subscribe = (method, rq, func)=>{

  api_request({
    type: method,
    url: '/api/v2/biogpt/subscribe/',
    data: rq,
    crud_name: '新建或更新订阅',
    success: func
  });
};

//aftergo获取推送列表
export const get_biogpt_push_list = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/mine/push/list/',
    crud_name: 'aftergo获取推送列表',
    success: func
  });
};
//aftergo查看推送详情
export const post_biogpt_push_info = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/push/info/',
    crud_name: 'aftergo查看推送详情',
    success: func
  });
};
//aftergo生成视频video或者音频audio
export const post_biogpt_pubmed_media = (media, data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/paper/'+ media +'/',
    crud_name: 'aftergo生成' + media,
    success: func
  });
};

//我的订阅
export const get_biogpt_subscribe = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/subscribe/',
    crud_name: '我的订阅',
    success: func
  });
};
//上传列表
export const get_biogpt_upload = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/paper/upload/list/',
    crud_name: '上传列表',
    success: func
  });
};
//上传pdf
export const post_biogpt_upload_pdf_file = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/paper/upload/file/',
    crud_name: '上传pdf',
    success: func
  });
};
//上传pdf提交解析
export const post_biogpt_upload_pdf = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/paper/upload/',
    crud_name: '上传pdf',
    success: func
  });
};
//aftergo问答
export const post_biogpt_chat_message = (data, func)=>{
  let stream = true;
  let url = '/api/v2/biogpt/aftergo/chat/message/';
  if(stream){
    data.stream = true;
    // get_answer_stream('/api/v2/biogpt/skip/aftergo/chat/message/', data, func);
    get_answer_stream(url, data, func);
    return;
  }
  api_request({
    data,
    type: 'post',
    url: url,
    crud_name: 'aftergo问答',
    success: func
  });
};
// 积分相关
export const get_biogpt_user_info = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/user/info/',
    crud_name: 'aftergo个人信息（积分）',
    success: func
  });
};
export const get_biogpt_admin_points = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/admin/points/list/',
    crud_name: 'aftergo用户积分列表（管理员）',
    success: func
  });
};
export const post_biogpt_admin_points = (data, func)=>{
  api_request({
    data,
    type: 'post',
    url: '/api/v2/biogpt/aftergo/admin/points/',
    crud_name: 'aftergo充值积分（管理员）',
    success: func
  });
};
export const get_biogpt_admin_points_records = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/points/records/',
    crud_name: 'aftergo查看积分变更记录',
    success: func
  });
};
export const get_biogpt_admin_points_daily = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/points/daily/',
    crud_name: 'aftergo查询每日积分消耗',
    success: func
  });
};
//查看系统关键词
export const get_biogpt_subscribe_keywords = ( func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/keywords/',
    crud_name: '查看系统关键词',
    success: func
  });
};
//删除订阅
export const delete_biogpt_subscribe = (data, func)=>{
  api_request({
    data,
    type: 'delete',
    url: '/api/v2/biogpt/subscribe/',
    crud_name: '删除订阅',
    success: func
  });
};
export const endpoint_127 = 'http://127.0.0.1';
export const endpoint_v = `${endpoint_127}:8011`;
export const endpoint_wangtao = `${endpoint_127}:8001`;
//黄威http://127.0.0.1:8011
export const post_check_tool_tcm_api = (rq, func, isDEV1)=>{
  if(isDEV1 === undefined) isDEV1 = isDEV;
  if(isDEV1){
    func({
      "code": "def vcf_to_maf(input-vcf):\n    \n    if not input-vcf.endswith(\".vcf\"):\n        raise ValueError(\"Invalid file name\")\n        \n\n    current_path = os.getcwd()\n    output_header0 = \".\".join(/io_data.split(\".\")[0:-1])\n\n    client = docker.from_env()\n\n    container_config = {\n    'image': \"vcf_to_maf:17201666423881028\",\n    'command': '/bin/bash',\n    'tty': True,\n    'stdin_open': True,\n    'volumes': {\n        current_path: {\n            'bind': '/io_data',\n            'mode': 'rw'\n        },\n        \"\": {\n            'bind': '/opt',\n            'mode': 'rw'\n        }\n    },\n    'detach': True\n    }\n    container = client.containers.run(**container_config)\n\n    command = f\"perl /opt/mskcc-vcf2maf/vcf2maf.pl --input-vcf /io_data/{input-vcf} --output-maf /io_data/{output_header0}.maf --tumor-id tumor --normal-id normal --ref-fasta /data/reference/hg19/ucsc.hg19.nochr.fasta --ncbi-build GRCh37 --species homo_sapiens --vep-data /data/reference/vep --vep-path /opt/vep/src/ensembl-vep/ --cache-version 97\"\n\n    output = container.exec_run(command)\n    # print(result.exit_code, result.output.decode('utf-8'))\n    container.stop()\n    container.remove()\n    if \"Error\" in output or \"error\" in output:\n        raise Exception(output)\n\n    output-maf = output_header0+\".maf\"\n    for f in [output-maf]:\n        if not os.path.exists(f):\n            raise FileNotFoundError(f\"{f} is not found\")\n    return output-maf",
      "error": "",
      "example": "```python\noutput-maf = vcf_to_maf(\"GJX-lung.pass.vcf\")\n\"\"\"\noutput-maf:\"GJX-lung.pass.maf\"\n\"\"\"\n```\n",
      "image_name": "vcf_to_maf:17201666423881028",
      "message": "success",
      "script_path": ""
    });
    return;
  }

  let url = endpoint_v + '/check_tool/';
  api_request({
    url: url,
    type: 'post',
    data: rq,
    crud_name: '本API端点 `/check_tool/` 旨在分析传入的Python代码片段，并提取其中的函数参数和返回值。',
    success: func
  });
};

//孙靖博http://127.0.0.1:8011
export const post_retriever = (rq, func)=>{
  let url = endpoint_v + '/retriever';
  api_request({
    url: url,
    type: 'post',
    data: rq,
    crud_name: '本API端点 `/check_tool/` 旨在分析传入的Python代码片段，并提取其中的函数参数和返回值。',
    success: func
  });
};
//王涛http://127.0.0.1:8001
export const post_search_pubmed = ( res, func)=>{
  if(isDEV){
    func({
      "code": 200,
      "response": {
        "message": "查询成功",
        "total_records": 10,
        "data": [
          {
            "PMID": 37683442,
            "Journal": "Respiratory medicine and research. 2023 Nov;84():101028.",
            "Abstract": "The ETAPES program is a national telemedicine experiment conducted in France between 2018 and 2023 to investigate whether home non-invasive ventilation (NIV) telemonitoring improves healthcare pathways in patients with chronic respiratory failure (CRF) and impacts healthcare organization. The program provides a combination of therapeutic education and NIV telemonitoring with data processed by an algorithm generating alerts. The TELVENT study objective was to analyze the evolution of ventilation quality in patients included in the ETAPES program.",
            "Paper_pdf": null,
            "Publish_Date": "2023-11-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Home NIV treatment quality in patients with chronic respiratory failure having participated to the French nationwide telemonitoring experimental program (The TELVENT study).",
            "First_Author": "Sandrine Pontier-Marchandise",
            "Ref_id": 7,
            "Authors": "Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,Sandrine Pontier-Marchandise,",
            "DOI": "10.1016/j.resmer.2023.101028",
            "Affiliation": "Department of Respiratory Medicine, Larrey Hospital, Toulouse University Hospital, Toulouse, France. Electronic address: pontier.s@chu-toulouse.fr.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38062597,
            "Journal": "Journal of the College of Physicians and Surgeons--Pakistan : JCPSP. 2023 Dec;33(12):1405-1409.",
            "Abstract": "To investigate the effect of the haemoglobin, albumin, lymphocyte, and platelet (HALP) score (Haemoglobin, Albumin, Lymphocyte, Platelet count) on survival as a new prognostic factor in metastatic bladder cancer.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "HALP Score as a New Prognostic Factor for Patients with Metastatic Bladder Cancer.",
            "First_Author": "Omer Acar",
            "Ref_id": 8,
            "Authors": "Omer Acar,Omer Acar,Omer Acar,Omer Acar,Omer Acar,Omer Acar,",
            "DOI": "10.29271/jcpsp.2023.12.1405",
            "Affiliation": "Department of Medical Oncology, Celal Bayar University, Manisa, Turkey.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38092797,
            "Journal": "Scientific reports. 2023 Dec;13(1):22135.",
            "Abstract": "The Arctic is subjected to all-encompassing disruptions in marine ecosystems caused by anthropogenic warming. To provide reliable estimates of how future changes will affect the ecosystems, knowledge of Arctic marine ecosystem responses to past environmental variability beyond the instrumental era is essential. Here, we present a novel approach on how to evaluate the state of benthic marine biotic conditions during the deglacial and Holocene period on the Northeast Greenland shelf. Benthic foraminiferal species were assigned traits (e.g., oxygen tolerance, food preferences) aiming to identify past faunal changes as a response to external forcing mechanisms. This approach was applied on sediment cores from offshore Northeast Greenland. We performed numerical rate-of-change detection to determine significant changes in the benthic foraminiferal traits. That way, the significant abrupt trait changes can be assessed across sites, providing a better understanding of the impact of climate drivers on the traits. Our results demonstrate that during the last ~ 14,000 years, bottom water oxygen is the main factor affecting the variability in the benthic foraminiferal faunas in this area. Our results show that significant changes in the traits correspond to drastic climate perturbations. Specifically, the deglacial-Holocene transition and mid-Holocene warm period exhibited significant change, with several trait turnovers.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Response of Arctic benthic foraminiferal traits to past environmental changes.",
            "First_Author": "Katrine Elnegaard Hansen",
            "Ref_id": 9,
            "Authors": "Katrine Elnegaard Hansen,Katrine Elnegaard Hansen,Katrine Elnegaard Hansen,",
            "DOI": "10.1038/s41598-023-47603-w",
            "Affiliation": "Paleoceanography and Paleoclimate Group, Department of Geoscience, Arctic Research Center and iClimate Center, Aarhus University, Aarhus, Denmark. keha@geus.dk.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 17111134,
            "Journal": "Applied microbiology and biotechnology. 2023 Dec;107(Suppl 1):1-7.",
            "Abstract": "We introduced a strategy for preparing a carbohydrate microarray and demonstrated its utility for characterizing carbohydrate binding and activities. We isolated the lipopolysaccharide (LPS) components from different bacteria and explored the possibility of immobilizing these glycoconjugates on a high-binding polystyrene plate. Carbohydrate-specific combination was examined by observing the binding of the blood group B analogic LPS O-polysaccharide from Escherichia coli on the high-binding polystyrene plate and anti-B from a broad spectra antibody of human blood serum. Strong binding of antibodies was screened, as it was evident that relative response value is two times higher than control. The hybridization results indicated that this method is a reliable technique for the detection of human intestinal bacteria and is expected to be applied in diagnostics and seroepidemiology.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Fabrication and application of carbohydrate microarray for analyzing human serum antibody-carbohydrate interaction.",
            "First_Author": "Gang-Liang Huang",
            "Ref_id": 11,
            "Authors": "Gang-Liang Huang,Gang-Liang Huang,Gang-Liang Huang,Gang-Liang Huang,",
            "DOI": "10.1007/s00253-006-0723-9",
            "Affiliation": "State Key Laboratory of Microbial Technology (SKLMT), Shandong University, Jinan, Shandong, 250100, People's Republic of China. hgl226@126.com.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-17",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 33764285,
            "Journal": "Cranio : the journal of craniomandibular practice. 2024 Jan;42(1):48-54.",
            "Abstract": "To evaluate the prevalence of sleep bruxism, related factors, and quality of life of preschool children and their families.",
            "Paper_pdf": null,
            "Publish_Date": "2024-01-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Factors associated with preschool children's sleep bruxism.",
            "First_Author": "Soraia Veloso da Costa",
            "Ref_id": 20,
            "Authors": "Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,Soraia Veloso da Costa,",
            "DOI": "10.1080/08869634.2021.1903663",
            "Affiliation": "University Center, UniFTC, Salvador, Bahia, Brazil.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2023-12-26",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38190799,
            "Journal": "Journal of the National Comprehensive Cancer Network : JNCCN. 2024 Jan;():1-14.",
            "Abstract": "We previously showed the 21-gene breast recurrence score (RS) has lower prognostic accuracy for non-Hispanic Black (NHB) compared with non-Hispanic White (NHW) women with estrogen receptor (ER)-positive/HER2-negative breast cancer. The purpose of this study was to determine the clinical validity of the RS for predicting chemotherapy benefit as recommended in the current NCCN Guidelines for Breast Cancer among women from diverse racial/ethnic groups.",
            "Paper_pdf": null,
            "Publish_Date": "2024-01-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Reduction in Breast Cancer Death With Adjuvant Chemotherapy Among US Women According to Race, Ethnicity, and the 21-Gene Recurrence Score.",
            "First_Author": "Hsiao-Ching Huang",
            "Ref_id": 35,
            "Authors": "Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,Hsiao-Ching Huang,",
            "DOI": "10.6004/jnccn.2023.7077",
            "Affiliation": "1Department of Pharmacy Systems, Outcomes and Policy, University of Illinois College of Pharmacy, Chicago, Illinois.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-01-09",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 34047283,
            "Journal": "Studies in health technology and informatics. 2023 Dec;311():25-43.",
            "Abstract": "Electronic patient data use and handling are critical issues in terms of privacy, confidentiality, security, and the Health Insurance Portability and Accountability Act (HIPAA) regulations. The risks associated with electronic patient data are not limited to identity theft but rather include a person's social, economic, and psychological well-being. However, there have not been many studies that have focused on the associated risk factors that could lead to these situations. This paper identifies those risks related to electronic patient data breaches by means of a grounded theory approach and develops a systemic risk management plan that enables engineering managers and risk managers to more effectively and efficiently overcome risks associated with electronic patient data. Purpose: The purpose of this paper is to identify the risks associated with electronic patient data breach using a grounded theory approach and also to recommend a set of guidelines to support a better, effective, and efficient system and thereby overcome these risks. Patients and methods: No patients were involved either to participate in this study or any of their opinions are reflected with this research.",
            "Paper_pdf": null,
            "Publish_Date": "2023-12-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Systemic Risk Management Plan for Electronic Medical Records (EMR): Why and How?",
            "First_Author": "Ziniya Zahedi",
            "Ref_id": 41,
            "Authors": "Ziniya Zahedi,Ziniya Zahedi,Ziniya Zahedi,",
            "DOI": "10.3233/SHTI200016",
            "Affiliation": "Georgetown University Law Center, Washington, DC, USA.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-01-15",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 37891782,
            "Journal": "Brain sciences. 2023 Oct;13(10):249-257.",
            "Abstract": "To date, no one has prospectively evaluated yoga intervention-induced changes in brain structure or function in adults with acquired brain injuries (ABI). Thus, this study was conducted to test the feasibility of acquiring neuroimaging data from adults with ABI before and after a yoga intervention.",
            "Paper_pdf": null,
            "Publish_Date": "2023-10-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Feasibility of Acquiring Neuroimaging Data from Adults with Acquired Brain Injuries before and after a Yoga Intervention.",
            "First_Author": "Jaclyn A Stephens",
            "Ref_id": 68,
            "Authors": "Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,Jaclyn A Stephens,",
            "DOI": "10.3390/brainsci13101413",
            "Affiliation": "Department of Occupational Therapy, Colorado State University, Fort Collins, CO 80524, USA.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-02-10",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 38224751,
            "Journal": "Chemosphere. 2024 Mar;351():141209.",
            "Abstract": "Perfluorooctanoic acid (PFOA) is an emerging pollutant that is non-biodegradable and presents severe environmental and human health risks. In this study, we present an effective and mild approach for PFOA degradation that involves the use of nitrogen-doped carbon foam anchored with nanoscale zero-valent iron (nZVI@NCF) to activate low concentration peroxymonosulfate (PMS) for the treatment. The nZVI@NCF/PMS system efficiently removed 84.4% of PFOA (2.4 μM). The active sites of nZVI@NCF including Fe",
            "Paper_pdf": null,
            "Publish_Date": "2024-03-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Degradation and mechanism of PFOA by peroxymonosulfate activated by nitrogen-doped carbon foam-anchored nZVI in aqueous solutions.",
            "First_Author": "Changyu Li",
            "Ref_id": 72,
            "Authors": "Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,Changyu Li,",
            "DOI": "10.1016/j.chemosphere.2024.141209",
            "Affiliation": "State Key Laboratory of Pollution Control and Resource Reuse, Key Laboratory of Surficial Geochemistry, Ministry of Education, School of Earth Sciences and Engineering, Hydrosciences Department, Nanjing University, Nanjing, 210023, China. Electronic address: carryleeee@163.com.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-02-13",
            "Citation": null,
            "PMCID": null
          },
          {
            "PMID": 37887431,
            "Journal": "Cartilage. 2024 Mar;15(1):37-46.",
            "Abstract": "To determine the clinical, safety, and radiological outcomes after biological resurfacing arthroplasty for the treatment of osteoarthritis (OA) of one or more joints of the midtarsal joint complex.",
            "Paper_pdf": null,
            "Publish_Date": "2024-03-01",
            "Disease": null,
            "Publication_Year": null,
            "NIHMS_ID": null,
            "Title": "Prospective Outcomes of a Biological Resurfacing Arthroplasty with Fascia Lata Autograft (BioJoint) for the Treatment of Osteoarthritis of the Midtarsal Joint Complex.",
            "First_Author": "Jari Dahmen",
            "Ref_id": 74,
            "Authors": "Jari Dahmen,Jari Dahmen,Jari Dahmen,",
            "DOI": "10.1177/19476035231206740",
            "Affiliation": "Department of Orthopedic Surgery and Sports Medicine, Amsterdam Movement Sciences, Amsterdam UMC, Location AMC, University of Amsterdam, Amsterdam, The Netherlands.",
            "Create_Date": "2024-07-07",
            "Modify_time": "2024-02-14",
            "Citation": null,
            "PMCID": null
          }
        ]
      }
    });
    return;
  }
  api_request({
    data: res,
    type: 'POST',
    url: endpoint_wangtao + '/get_pubmeds/',
    success: func,
    api_info: {api_name: "检索pubmed", api_prefix: ""}
  })
};
//aftergo 获取paper列表
export const get_aftergo_paper_list = (data, func)=>{
  api_request({
    data,
    type: 'get',
    url: '/api/v2/biogpt/aftergo/paper/list/',
    success: func,
    api_info: {api_name: "aftergo 获取paper列表", api_prefix: ""}
  })
};
export const jumpToDetail = (upload_no, paper_no)=>{
    if(upload_no && paper_no) window.location.href = ('/push/paper/?paper_no=' + paper_no + '&upload_no=' + upload_no);
};
//paper 查看我的解析记录
export const get_aftergo_paper_upload_mine = (func)=>{
  api_request({
    type: 'get',
    url: '/api/v2/biogpt/aftergo/paper/upload/mine/',
    success: func,
    api_info: {api_name: "查看上传列表（用户） ", api_prefix: ""}
  })
};
export const getMediaText = (status)=>{
  if(status === 0) return '未创建';
  if(status === 1) return '生成中';
  if(status === -1) return '生成失败';
  if(status === 2) return '生成成功';
  return status;
};